import React, { useState } from 'react';

// Hints only: browser detection never changes permissions or the location gate.
export function detectLocationGuide({ userAgent = '', platform = '', maxTouchPoints = 0 } = {}) {
  const ios = /iPhone|iPad|iPod/i.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1);
  const embedded = /FBAN|FBAV|Instagram|Line\/|; wv\)/i.test(userAgent);
  if (embedded) return 'other';
  if (ios && /CriOS\//.test(userAgent)) return 'ios-chrome';
  if (ios && /Version\/.+Safari\//.test(userAgent) && !/FxiOS|EdgiOS|OPiOS/.test(userAgent)) return 'ios-safari';
  if (/Android/.test(userAgent) && /Chrome\//.test(userAgent) && !/SamsungBrowser|EdgA|OPR\//.test(userAgent)) return 'android-chrome';
  return 'other';
}

// Official permission paths: Apple iPhone guide iphb01fc3c85 and Google Chrome
// Help 114662 / 142065. Keep site permission separate from phone permission.
const guides = {
  'ios-safari': {
    label: 'iPhone / iPad · Safari',
    steps: [<>Tap the page menu <span className="location-help-muted">(aA on older iOS)</span> → <strong>Website Settings</strong> or <strong>…</strong>.</>, <>Set <strong>Location → Allow</strong>, then try again.</>],
    more: <>In phone Settings → Privacy &amp; Security → Location Services, turn location on. Select <strong>Safari Websites → While Using the App</strong>.</>,
  },
  'android-chrome': {
    label: 'Android · Chrome',
    steps: [<>Tap the icon beside the address → <strong>Permissions</strong>.</>, <>Set <strong>Location → Allow</strong>, then try again.</>],
    more: <>Turn on your phone’s Location. In Settings → Apps → Chrome → Permissions → Location, choose <strong>Allow only while using the app</strong>. Names may vary by phone.</>,
  },
  'ios-chrome': {
    label: 'iPhone / iPad · Chrome',
    steps: [<>Open phone <strong>Settings</strong>, find <strong>Chrome → Location</strong>.</>, <>Choose <strong>While Using the App</strong>. Return here, retry, and allow the site’s request.</>],
    more: <>Check Settings → Privacy &amp; Security → Location Services is on. If the site is still blocked, open this same QR link in <strong>Safari</strong> and allow location there.</>,
  },
  other: {
    label: 'Other browser',
    steps: [<>Open your browser’s <strong>site settings</strong> for this page.</>, <>Allow <strong>Location</strong>, then try again.</>],
    more: <>Inside another app? Open the <strong>same QR link</strong> in Safari on iPhone or Chrome on Android, then choose that guide above. Also check your phone allows location for the browser.</>,
  },
};

export default function LocationHelp() {
  const [selected, setSelected] = useState(() => detectLocationGuide(typeof navigator === 'undefined' ? {} : navigator));
  const guide = guides[selected];
  return <section className="location-help" aria-label="Enable location">
    <select className="location-help-browser" aria-label="Location help browser" value={selected} onChange={event => setSelected(event.target.value)}>
      {Object.entries(guides).map(([value, { label }]) => <option key={value} value={value}>{label}</option>)}
    </select>
    <ol>{guide.steps.map((step, index) => <li key={index}>{step}</li>)}</ol>
    <details key={selected}>
      <summary>Still blocked?</summary>
      <p>{guide.more}</p>
    </details>
  </section>;
}
